import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'
// import { resolve } from 'uri-js';
// import concentrator from '../components/meterReadingManagement/concentrator.vue';
// import collection from '../components/meterReadingManagement/collection.vue';

// 懒加载方式，当路由被访问的时候才加载对应组件
//const Login = resolve => require(['@/components/Login'], resolve)

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    routes: [

        // 登录页面axios
        {
            path: '/',
            name: 'login',
            component: resolve => require(['../components/login.vue'], resolve),
            meta: {
                title: 'NB表登录'
            },
        },
        // 可视化主页
        {
            path: '/dynamicHomepage',
            name: 'dynamicHomepage',
            component: resolve => require(['../components/dynamicHomepage/home.vue'], resolve),
            meta: {
                title: '可视化主页'
            },
        },
        // 空白页跳转
        {
            path: '/empty',
            name: 'empty',
            component: resolve => require(['../components/empty.vue'], resolve),
            meta: {
                title: "空白页"
            }
        },
        {
            path: '/common/Home',
            name: 'Home',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: {
                title: '平台主页'
            },
            children: [


                // 营收管理 --------------------------------------------------------------------------------
                // 业主档案
                {
                    path: '/revenueManagement/archiveManagement',
                    name: 'archiveManagement',
                    component: resolve => require(['../components/revenueManagement/archiveManagement/home.vue'], resolve),
                    meta: {
                        title: "业主档案"
                    }
                },
                // new业主档案
                {
                    path: '/revenueManagement/newArchiveManagement',
                    name: 'archiveManagement',
                    component: resolve => require(['../components/revenueManagement/archiveManagement/newArchiveManagement.vue'], resolve),
                    meta: {
                        title: "业主档案"
                    }
                },
                // 水量水费
                {
                    path: '/revenueManagement/operationPage',
                    name: 'accountQuery',
                    component: resolve => require(['../components/revenueManagement/accountQuery/home.vue'], resolve),
                    meta: {
                        title: "水量水费"
                    }
                },
                // 水费分析
                {
                    path: '/revenueManagement/feeAnalysisPage',
                    name: 'accountQuery',
                    component: resolve => require(['../components/revenueManagement/feeAnalysisPage.vue'], resolve),
                    meta: {
                        title: "水费分析"
                    }
                },
                // 缴费管理
                {
                    path: '/revenueManagement/feeManagement',
                    name: 'feeManagement',
                    component: resolve => require(['../components/revenueManagement/feeManagement/home.vue'], resolve),
                    meta: {
                        title: "缴费管理"
                    }
                },
                // 对账明细
                {
                    path: '/revenueManagement/accountManagement',
                    name: 'accountManagement',
                    component: resolve => require(['../components/revenueManagement/accountManagement.vue'], resolve),
                    meta: {
                        title: "对账明细"
                    }
                },
                // 通知公告
                {
                    path: '/revenueManagement/notifications',
                    name: 'notifications',
                    component: resolve => require(['../components/revenueManagement/notifications.vue'], resolve),
                    meta: {
                        title: "通知公告"
                    }
                },
                // 业主反馈
                {
                    path: '/revenueManagement/accountFeedback',
                    name: 'accountFeedback',
                    component: resolve => require(['../components/revenueManagement/accountFeedback.vue'], resolve),
                    meta: {
                        title: "业主反馈"
                    }
                },

                // 抄表管理 ---------------------------------------------------------------------------------
                // 水表管理
                {
                    path: '/meterReadingManagements/meterData',
                    name: 'deviceManagement',
                    component: resolve => require(['../components/meterReadingManagements/deviceManagement/home.vue'], resolve),
                    meta: {
                        title: "水表信息"
                    }
                },
                // 异常水表
                {
                    path: '/meterReadingManagements/testFault',
                    name: 'testFault',
                    component: resolve => require(['../components/meterReadingManagements/testFault'], resolve),
                    meta: {
                        title: "异常水表"
                    }
                },
                // 重号水表
                {
                    path: '/meterReadingManagements/repeatMeter',
                    name: 'repeatMeter',
                    component: resolve => require(['../components/meterReadingManagements/repeatMeter.vue'], resolve),
                    meta: {
                        title: "重号水表"
                    }
                },
                // 故障诊断
                {
                    path: '/meterReadingManagements/faultMeter',
                    name: 'faultMeter',
                    component: resolve => require(['../components/meterReadingManagements/faultMeter'], resolve),
                    meta: {
                        title: "异常查询"
                    }
                },
                // 操作日志
                {
                    path: '/meterReadingManagements/operationLog',
                    name: 'operationLog',
                    component: resolve => require(['../components/meterReadingManagements/operationLog.vue'], resolve),
                    meta: {
                        title: "操作日志"
                    }
                },
                // 登陆日志
                {
                    path: '/meterReadingManagements/loginLog',
                    name: 'loginLog',
                    component: resolve => require(['../components/meterReadingManagements/loginLog.vue'], resolve),
                    meta: {
                        title: "登陆日志"
                    }
                },
                // 一键导入
                {
                    path: '/meterReadingManagements/automaticImport',
                    name: 'automaticImport',
                    component: resolve => require(['../components/meterReadingManagements/automaticImport.vue'], resolve),
                    meta: {
                        title: "一键导入"
                    }
                },
                // 批量报装
                {
                    path: '/meterReadingManagements/meterImportMultiple',
                    name: 'meterImportMultiple',
                    component: resolve => require(['../components/meterReadingManagements/meterImportMultiple.vue'], resolve),
                    meta: {
                        title: "批量报装Multiple"
                    }
                },
                // new  批量报装
                {
                    path: '/meterReadingManagements/meterImportOnce',
                    name: 'meterImportOnce',
                    component: resolve => require(['../components/meterReadingManagements/meterImportOnce.vue'], resolve),
                    meta: {
                        title: "水表报装"
                    }
                },
                // 区域管理
                {
                    path: '/meterReadingManagements/regionManagement',
                    name: 'regionManagement',
                    component: resolve => require(['../components/meterReadingManagements/regionManagement'], resolve),
                    meta: {
                        title: "小区管理"
                    }
                },
                // 水表档案
                {
                    path: '/meterReadingManagements/waterMeterArchives',
                    name: 'waterMeterArchives',
                    component: resolve => require(['../components/meterReadingManagements/waterMeterArchives'], resolve),
                    meta: {
                        title: "水表档案"
                    }
                },
                // 换表记录
                {
                    path: '/meterReadingManagements/deviceChangeHistory',
                    name: 'deviceChangeHistory',
                    component: resolve => require(['../components/meterReadingManagements/deviceChangeHistory'], resolve),
                    meta: {
                        title: "换表记录"
                    }
                },
                // 用量导出
                {
                    path: '/meterReadingManagements/meterExport',
                    name: 'meterExport',
                    component: resolve => require(['../components/meterReadingManagements/meterExport.vue'], resolve),
                    meta: {
                        title: "用量导出"
                    }
                },
                // 集抄器水表
                {
                    path: '/meterReadingManagements/collectorMeter',
                    name: 'meterReadingManagement',
                    component: resolve => require(['../components/meterReadingManagements/collectorMeter/home.vue'], resolve),
                    meta: {
                        title: '集抄器水表'
                    }
                },
                // NB水表
                {
                    path: '/meterReadingManagements/NBMeter',
                    name: 'NBMeter',
                    component: resolve => require(['../components/meterReadingManagements/NBMeter/home.vue'], resolve),
                    meta: {
                        title: "水表抄读"
                    }
                },
                // 用量分析
                {
                    path: '/meterReadingManagements/enprAnalysis',
                    name: 'enprAnalysis',
                    component: resolve => require(['../components/meterReadingManagements/enprAnalysis'], resolve),
                    meta: {
                        title: "用量分析"
                    }
                },


                // NB卡表
                {
                    path: '/meterReadingManagements/NBCardMeter',
                    name: 'NBCardMeter',
                    component: resolve => require(['../components/meterReadingManagements/NBCardMeter/home.vue'], resolve),
                    meta: {
                        title: "NB 卡表"
                    }
                },
                // 集中器界面
                {
                    path: '/meterReadingManagements/concentratorMeter',
                    name: 'concentratorMeter',
                    component: resolve => require(['../components/meterReadingManagements/concentratorMeter.vue'], resolve),
                    meta: {
                        title: "集中器"
                    }
                },

                // 未报装水表
                // {
                //     path: '/meterReadingManagements/NotReportedMeter',
                //     name: 'notReportedMeter',
                //     component: resolve => require(['../components/meterReadingManagements/NotReportedMeter/home_notReportedMeter.vue'], resolve),
                //     meta: {
                //         title: "未报装水表"
                //     }
                // },
                // LoRaWAN水表
                {
                    path: '/meterReadingManagements/LoRaWANMeter',
                    name: 'LoRaWANMeter',
                    component: resolve => require(['../components/meterReadingManagements/LoRaWANMeter/home.vue'], resolve),
                    meta: {
                        title: "Lorawan 水表"
                    }
                },
                {
                    path: '/meterReadingManagements/meterSearch',
                    name: 'meterSearch',
                    component: resolve => require(['../components/meterReadingManagements/meterSearch.vue'], resolve),
                    meta: {
                        title: "水表查询"
                    }
                },


                // 管理员仅有页面、独有权利 ------------------------------------------------------------
                // 水司管理
                {
                    path: '/superAdmin/enprManagement',
                    name: 'enprManagement',
                    component: resolve => require(['../components/superAdmin/enprManagement.vue'], resolve),
                    meta: {
                        title: '水司管理'
                    }
                },

                // 故障管理
                {
                    path: '/superAdmin/faultManagement',
                    name: 'faultManagement',
                    component: resolve => require(['../components/superAdmin/faultManagement.vue'], resolve),
                    meta: {
                        title: '故障管理'
                    }
                },

                // 超级管理员权限系统设置
                // 成员管理
                {
                    path: '/superAdmin/userManagement',
                    name: 'userManagement',
                    component: resolve => require(['../components/superAdmin/user.vue'], resolve),
                    meta: {
                        title: '成员管理'
                    }
                },

                // 角色管理
                {
                    path: '/superAdmin/roleManagement',
                    name: 'roleManagement',
                    component: resolve => require(['../components/superAdmin/role.vue'], resolve),
                    meta: {
                        title: '角色管理'
                    }
                },
                // 菜单管理
                {
                    path: '/superAdmin/menuManagement',
                    name: 'menuManagement',
                    component: resolve => require(['../components/superAdmin/menu.vue'], resolve),
                    meta: {
                        title: '菜单管理'
                    }
                },
                // 水司管理
                {
                    path: '/superAdmin/enterpriseManagement',
                    name: 'enterpriseManagement',
                    component: resolve => require(['../components/superAdmin/enterpriseManagement.vue'], resolve),
                    meta: {
                        title: '水司管理'
                    }
                },
                // 权限设置 -----------------------------------------------------------------------------------
                // 角色管理
                // {
                //     path: '/permissionSet/roleManagement',
                //     name: 'roleManagement',
                //     component: resolve => require(['../components/permissionSet/roleManagement.vue'], resolve),
                //     meta: {
                //         title: "角色管理"
                //     }
                // },
                // 管理员账户下业主管理
                // 业主管理
                {
                    path: '/permissionSet/operatorManagement',
                    name: 'operatorManagement',
                    component: resolve => require(['../components/permissionSet/operatorManagement.vue'], resolve),
                    meta: {
                        title: "业主管理"
                    }
                },
                // 新增成员
                {
                    path: '/permissionSet/addOperator',
                    name: 'addOperator',
                    component: resolve => require(['../components/permissionSet/addOperator.vue'], resolve),
                    meta: {
                        title: "新增成员"
                    }
                },

                // 设置 -----------------------------------------------------------------------------------
                // 基本设置
                {
                    path: '/settings/basicSetting',
                    name: 'basicSetting',
                    component: resolve => require(['../components/settings/basicSetting.vue'], resolve),
                    meta: {
                        title: "基本设置"
                    }
                },
                // 微信账户设置
                {
                    path: '/settings/wechatSetting',
                    name: 'wechatSetting',
                    component: resolve => require(['../components/settings/wechatSetting.vue'], resolve),
                    meta: {
                        title: "微信账户设置"
                    }
                },
                // 水价设置
                {
                    path: '/settings/priceSetting',
                    name: 'priceSetting',
                    component: resolve => require(['../components/settings/priceSetting.vue'], resolve),
                    meta: {
                        title: "水价设置"
                    }
                },

                // 批量开户
                {
                    path: '/accountManagement/batchAccountOpening',
                    name: '',
                    component: resolve => require(['../components/revenueManagement/accountManagement/home.vue'], resolve),
                    meta: {
                        title: "批量开户"
                    }
                },

                // 用水量分析预测 -----------------------------------------------------------------------------------



            ]
        },
        {
            path: '/404',
            name: '404',
            component: resolve => require(['../components/404.vue'], resolve)
        },
        {
            path: '/403',
            name: '403',
            component: resolve => require(['../components/403.vue'], resolve)
        },
        {
            path: '*', // 路由错误
            redirect: '/404' // 重定向
        }
    ]
})

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    const role = sessionStorage.getItem('userName');
    let element = document.documentElement;
    if (from.path == '/homePage-data') {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
    if (to.path == '/homePage-data') {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
        }
    }
    if (to.path == '/login') {
        next();
    } else if (!role && to.path !== '/') {
        next('/');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next('/setting') : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: "确定"
            });
        } else {
            next();
        }
    }

    // 判断是否存在路由
    console.log(store)
    let hasRoute = store.state.menu.hasRoutes;
    const token = sessionStorage.getItem('Authorization')
    // 判断是否登录
    let userName = localStorage.getItem("userName");

    // 若进入的是 login，这直接进入
    if (to.path == '/login') {
        next()
        // 没有登录则直接跳转到 login
    }
    // else if (!token) {
    //     next({ path: '/login' })
    // }
    // else if (token && !hasRoute) {
    //     // 请求菜单，存入 Vuex 中的 menuList 即可（调用 setMenuList）
    //     hasRoute = true
    //     store.commit('menu/changeRouteStatus', true)
    // }


})

// 导航转成路由
const menuToRoute = (menu) => {

    if (!menu.component) {
        return null
    }

    let route = {
        name: menu.name,
        path: menu.path,
        meta: {
            icon: menu.icon,
            title: menu.title
        }
    }
    return route
}


// 导出
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js